// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
require("@rails/activestorage").start();

import "./sentry-init.js";

import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
window.Stimulus = Application.start();

import JQuery from "jquery";
window.$ = JQuery;
// Superusers and Admins
import "./style.scss";
import "./navigation.scss";
import "./search-form.scss";
import "./material-theme.scss";
import "./devise.scss";
import "./modals.scss";
import "./resources-page.scss";
import "./accordions.scss";
import "./shared/accordion";
import "@fortawesome/fontawesome-free/css/all.min.css";

function importAll(r) {
  r.keys().forEach(r);
}
importAll(require.context("./admins/", true, /.(js|scss)$/));
importAll(require.context("./superusers/", true, /.(js|scss)$/));

import SortableList from "./superusers/sortable";
import "./superusers/sortable.css";
import "./superusers/organization-pages.scss";
import "./superusers/tinymce.js";
import "./shared/tinymce.scss";
export default (function () {
  document.addEventListener("DOMContentLoaded", SortableList, false);
})();
require("tinymce");
require("@rails/actiontext");

require.context("../images", true);

const context = require.context("./controllers", true, /\.js$/);
Stimulus.load(definitionsFromContext(context));

import {
  RaincoatMDCTextFieldController,
  RaincoatMDCButtonController,
  RaincoatMDCBannerController,
  RaincoatMDCTopAppBarController,
  RaincoatMDCDialogController,
  RaincoatMDCDataTableController,
  RaincoatMDCSelectController,
  RaincoatMDCCardController,
  RaincoatMDCTooltipController,
  RaincoatMDCTabBarController
} from "raincoat";

Stimulus.register("mdc--banner", RaincoatMDCBannerController);
Stimulus.register("mdc--text-field", RaincoatMDCTextFieldController);
Stimulus.register("mdc--button", RaincoatMDCButtonController);
Stimulus.register("mdc--top-app-bar", RaincoatMDCTopAppBarController);
Stimulus.register("mdc--dialog", RaincoatMDCDialogController);
Stimulus.register("mdc--data-table", RaincoatMDCDataTableController);
Stimulus.register("mdc--select", RaincoatMDCSelectController);
Stimulus.register("mdc--card", RaincoatMDCCardController);
Stimulus.register("mdc--tooltip", RaincoatMDCTooltipController);
Stimulus.register("mdc--tab-bar", RaincoatMDCTabBarController);

Rails.start();

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
